<template>
  <div class="offers-archive-view">
    <!-- Toast info - pobieranie -->
    <div v-if="showInfoToast" class="info-toast">
      ⏳ Pobieranie ofert...
    </div>
    
    <!-- Toast success - zakończone -->
    <div v-if="showToast" class="success-toast">
      ✓ Oferty zostały pobrane ({{ filteredOffers.length }})
    </div>

    <!-- HEADER -->
    <div class="page-header">
      <div class="header-left">
        <router-link to="/offers">
          <button class="btn btn-primary">
            + Nowa oferta
          </button>
        </router-link>
        
        <div class="tabs">
          <button @click="getData()" class="tab tab-filter" :disabled="isLoading">
            <span v-if="isLoading" class="spinner"></span>
            <span v-else>🔄</span>
            {{ isLoading ? 'Pobieranie...' : 'Pobierz oferty' }}
          </button>
        </div>
      </div>

      <input
        v-model="search"
        class="search-input"
        type="search"
        placeholder="Wyszukaj ofertę..."
      />
    </div>

    <!-- Filtry danych -->
    <div class="filters-section">
      <div class="filter-group">
        <label class="filter-label">📅 Data od:</label>
        <input type="date" v-model="lastOffersStartDate" class="filter-input" />
      </div>
      <div class="filter-group">
        <label class="filter-label">📅 Data do:</label>
        <input type="date" v-model="lastOffersEndDate" class="filter-input" />
      </div>
      <div class="filter-group">
        <label class="filter-label">🔢 Ilość:</label>
        <input type="number" v-model="lastOffers" class="filter-input" placeholder="100" />
      </div>
    </div>

    <!-- SUMMARY -->
    <div class="summary">
      <div class="summary-item">
        <span class="summary-label">Liczba ofert</span>
        <span class="summary-value">{{ filteredOffers.length }}</span>
      </div>

      <div class="summary-item">
        <span class="summary-label">Wartość całkowita netto</span>
        <span class="summary-value">{{ totalNettoValue.toFixed(2) }} zł</span>
      </div>

      <div class="summary-item">
        <span class="summary-label">Średnia wartość oferty</span>
        <span class="summary-value">{{ averageOfferValue.toFixed(2) }} zł</span>
      </div>
    </div>

    <!-- TABLE -->
    <div class="table-container">
      <table class="offers-table">
        <thead>
          <tr>
            <th>Kontrahent</th>
            <th>Numer oferty</th>
            <th>Data</th>
            <th>Urządzenie</th>
            <th>Kwota netto</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="offer in filteredOffers" :key="offer.id" class="payment-row" @click="openOfferModal(offer)">
            <td>{{ offer.contractor }}</td>
            <td>{{ offer.offerNumber }}</td>
            <td>
              <span class="date-badge">
                {{ new Date(offer.date.seconds * 1000).toLocaleDateString() }}
              </span>
            </td>
            <td>{{ offer.offer ? offer.offer[0].name : '-' }}</td>
            <td>
              <span class="price">{{ offer.netto.toFixed(2) }} zł</span>
            </td>
            <td>
              <button class="btn-details" @click.stop="openOfferModal(offer)">
                Szczegóły
              </button>
              <button class="btn-duplicate" @click.stop="duplicateOffer(offer)">
                📋 Powiel
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <offer-modal-archive @closeModal="closeModal()" :offer="offer"></offer-modal-archive>
  </div>
</template>
<script>
import { mapState } from "vuex";
import OfferModalArchive from "../components/OfferModalArchive";

export default {
  data() {
    return {
      //   installation: {
      //     brand: "",
      //     model: "",
      //     plate: "",
      //     vin: "",
      //     year: "",
      //     imageUrl: "",
      //   },
      //   openForm: false,
      search: "",
      installation: "",
      lastOffers:100,
      lastOffersEndDate:"",
      lastOffersStartDate:"",
      offer: [],
      isLoading: false,
      showToast: false,
      showInfoToast: false,
    };
  },
  components: {
    "offer-modal-archive": OfferModalArchive,
  },

  computed: {
    ...mapState(["userProfile", "offers"]),
    sortedOffers() {
      return this.offers
        .slice()
        .sort((a, b) => new Date(b.createOn.seconds) - new Date(a.createOn.seconds));
    },
    filteredOffers() {
      return this.sortedOffers.filter((item) => {
        if (item.contractor.includes(this.search)) {
          return item;
        } else if (item.offerNumber.toUpperCase().includes(this.search.toUpperCase())) {
          return item;
        }
      });
    },
    totalNettoValue() {
      return this.filteredOffers.reduce((sum, offer) => sum + (offer.netto || 0), 0);
    },
    averageOfferValue() {
      return this.filteredOffers.length > 0 
        ? this.totalNettoValue / this.filteredOffers.length 
        : 0;
    },
  },
  methods: {
    //    openInstallationModal(installation) {
    //   this.$modal.show("installation-modal");
    //   this.installation = installation;
    // },
    openOfferModal(offer) {
      console.log(offer);
      window.scrollTo(0, 0);
      this.offer = offer;
      // Czekamy aż Vue zaktualizuje dane przed pokazaniem modala
      this.$nextTick(() => {
        this.$modal.show("offer-modal-archive");
      });
    },
    closeModal() {
      setTimeout(() => {
        // this.events = [];
        // console.log(this.installations);
        //   //   const item1 = this.config.chart.items["1"];
        //   //   item1.label = "label changed dynamically";
        //   //   item1.time.end += 2 * 24 * 60 * 60 * 1000;
        // this.setEvents();
      }, 100);
      this.$modal.hide("offer-modal-archive");
    },
    getData() {
      // Ręczne przeładowanie z parametrami z formularza
      this.isLoading = true;
      this.showInfoToast = true;
      
      // Ustawiamy timeout - jeśli po 3 sekundach nadal loading, ukrywamy
      const loadingTimeout = setTimeout(() => {
        this.isLoading = false;
      }, 3000);
      
      this.$store.dispatch("getOffers", {
        startDate: this.lastOffersStartDate,
        endDate: this.lastOffersEndDate,
        lastOffers: this.lastOffers
      });
      
      // Ukryj loader po krótkiej chwili (Firebase snapshot zazwyczaj jest szybki)
      setTimeout(() => {
        this.isLoading = false;
        this.showInfoToast = false;
        clearTimeout(loadingTimeout);
        this.showSuccessToast();
      }, 1000);
    },
    showSuccessToast() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
    duplicateOffer(offerToDuplicate) {
      // Przygotuj nową ofertę z danymi z powielanej
      // Stare oferty mogą nie mieć pola offerHeader, więc użyj header jako fallback
      const duplicatedOffer = {
        contractor: offerToDuplicate.contractor,
        date: new Date(),
        offer: JSON.parse(JSON.stringify(offerToDuplicate.offer)), // Głębokie kopie
        vat: offerToDuplicate.vat,
        netto: offerToDuplicate.netto,
        brutto: offerToDuplicate.brutto,
        imageUrl: offerToDuplicate.imageUrl,
        offerHeader: offerToDuplicate.offerHeader || offerToDuplicate.header || "",
        header: offerToDuplicate.header2 || offerToDuplicate.header || "",
        notice: offerToDuplicate.notice,
        user: offerToDuplicate.user,
        header2: offerToDuplicate.header2 || "",
        subheader: offerToDuplicate.subheader,
      };

      // Przechowaj powielaną ofertę tymczasowo
      sessionStorage.setItem('duplicatedOffer', JSON.stringify(duplicatedOffer));
      
      // Przejdź do formularza nowej oferty
      this.$router.push('/offers');
      
      // Po przejściu, załaduj dane do formularza
      this.$nextTick(() => {
        this.$root.$emit('loadDuplicatedOffer', duplicatedOffer);
      });
    },
  },
  mounted() {
    // Pobierz dane tylko jeśli nie ma żadnych ofert w store
    // To pozwala zachować wcześniej pobrane dane przy przełączaniu zakładek
    if (!this.offers || this.offers.length === 0) {
      // Automatyczne ładowanie ofert z domyślnym zakresem dat (ostatnie 3 miesiące)
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 3);
      const endDate = new Date();
      
      this.$store.dispatch("getOffers", {
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
        lastOffers: this.lastOffers || 50
      });
    }
  },
  beforeDestroy() {
    // NIE czyścimy danych - pozwalamy im zostać w store
    // this.$store.commit('unsubscribeListener', 'offers');
  },
};
</script>

<style scoped>
.offers-archive-view {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* HEADER */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 24px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.tabs {
  display: flex;
  gap: 4px;
  background: white;
  padding: 4px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.tab {
  padding: 10px 20px;
  border-radius: 6px;
  color: #6c757d;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab:hover:not(:disabled) {
  background: #f8f9fa;
  color: #495057;
}

.tab:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tab-filter:hover:not(:disabled) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

/* Spinner animation */
.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Toast powiadomienia */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.4);
  z-index: 10000;
  font-weight: 600;
  animation: slideIn 0.3s ease-out;
}

.info-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  z-index: 10000;
  font-weight: 600;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.tab-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.search-input {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  min-width: 300px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* FILTRY */
.filters-section {
  background: white;
  padding: 20px 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  display: flex;
  gap: 20px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-input {
  padding: 10px 14px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  color: #2c3e50;
  transition: all 0.2s ease;
  min-width: 150px;
}

.filter-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* SUMMARY */
.summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.summary-item {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  overflow: hidden;
}

.summary-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.summary-item:nth-child(2)::before {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
}

.summary-item:nth-child(3)::before {
  background: linear-gradient(135deg, #fd7e14 0%, #ffc107 100%);
}

.summary-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-left: 12px;
}

.summary-value {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-left: 12px;
}

/* TABLE */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

.offers-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.offers-table thead {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.offers-table th {
  padding: 18px 20px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  z-index: 10;
}

.offers-table tbody tr {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.offers-table tbody tr::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #e9ecef 50%, transparent 100%);
}

.offers-table tbody tr:hover {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  transform: scale(1.01);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  z-index: 1;
}

.offers-table td {
  padding: 20px;
  font-size: 14px;
  color: #2c3e50;
  vertical-align: middle;
}

.date-badge {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-block;
  white-space: nowrap;
}

.price {
  font-weight: 600;
  color: #28a745;
  font-size: 14px;
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-block;
}

.btn-details {
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-details:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-details:active {
  transform: translateY(0);
}

.btn-duplicate {
  padding: 8px 12px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-left: 6px;
}

.btn-duplicate:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.btn-duplicate:active {
  transform: translateY(0);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .offers-archive-view {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }

  .header-left {
    flex-direction: column;
    width: 100%;
  }

  .tabs {
    width: 100%;
  }

  .search-input {
    min-width: 100%;
  }

  .filters-section {
    flex-direction: column;
  }

  .filter-input {
    width: 100%;
  }

  .table-container {
    overflow-x: auto;
    border-radius: 8px;
  }

  .offers-table {
    min-width: 900px;
  }

  .offers-table th,
  .offers-table td {
    padding: 12px;
    font-size: 13px;
  }
}
</style>
